<script lang="ts">
  import * as Table from "$lib/components/ui/table";
  import { fakeProjectPrices } from "$src/domain/projects/items/FakeProjectDetail";
  import type {
    MarginDetail,
    ProjectPrices,
  } from "$src/domain/projects/ProjectDetail";
  import * as Card from "$lib/components/ui/card/index.js";
  import { t } from "svelte-i18n";
  import { getTranslation } from "$src/presentation/core/TranslatedTextUtils";
  import { languageCode } from "$src/presentation/core/languageCode";
  import Switch from "$lib/components/ui/switch/switch.svelte";
  import { Label } from "$lib/components/ui/label";
  import { formatCurrency } from "$src/presentation/core/currencyUtils";
  import PriceMarginAmount from "./price-margin-amount.svelte";
  import { isEditActive } from "$src/application/main/mainTemplateStore";
  import PaymentScheduleTable from "./payment-schedule-table.svelte";
  import TotalAmountsTable from "./total-amounts-table.svelte";
  import { projectDraft, projectOriginal } from "$src/application/projects/stores/projectStore";
  import { isQuoteStep } from "$src/domain/projects/WorkflowMap";

  export let groupStoreId: number;
  export let marginVisible: boolean = false;

  let projectPrices: ProjectPrices = fakeProjectPrices;

  let displayIncVat: boolean = true;


  function sortByOrder(categories: MarginDetail[]) {
    return categories.slice().sort((a, b) => a.order - b.order);
  }
</script>

<Card.Root class="">
  <Card.Header id="priceTable" class="pb-1">
    <Card.Title>{$t("page.projects.detail.amounts.title")}</Card.Title>
  </Card.Header>
  <Card.Content class="flex flex-row justify-around flex-wrap gap-4">
    
    {#if $isEditActive && !isQuoteStep($projectDraft.currentStep) }
      <PaymentScheduleTable {groupStoreId} />
    {:else if !isQuoteStep($projectOriginal.currentStep) }
      <PaymentScheduleTable {groupStoreId} />
    {/if}

    <Table.Root class="text-right text-xs caption-top max-w-xs {$isEditActive ? 'self-start' : ''}">
      <Table.Caption class="text-md text-left">
        <div class="flex flex-row justify-between">
          <div>Aperçu par catégorie d'article</div>
          <div class="flex text-xs items-center space-x-2">
            <Switch id="vat-mode" bind:checked={displayIncVat} />
            <Label for="vat-mode" class="font-normal text-xs cursor-pointer">
              {#if displayIncVat}
                TVA incluse
              {:else}
                TVA exclue
              {/if}
            </Label>
          </div>
        </div>
      </Table.Caption>
      <Table.Header>
        <Table.Row>
          <Table.Head class="text-left">Catégorie</Table.Head>
          <Table.Head class="max-w-14 text-right">Total</Table.Head>
          <Table.Head class="max-w-14 text-right">Remise</Table.Head>
          {#if marginVisible}
            <Table.Head class="max-w-14 text-right">Marge</Table.Head>
          {/if}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {#each sortByOrder(projectPrices.byCategories) as margin}
          <Table.Row>
            <Table.Cell class="text-left">
              {getTranslation(margin.category, $languageCode)}
            </Table.Cell>
            {#if displayIncVat}
              <Table.Cell class="text-right">
                {formatCurrency(margin.amountIncVat, projectPrices.currency)}
              </Table.Cell>
            {:else}
              <Table.Cell>
                {formatCurrency(margin.amountExVat, projectPrices.currency)}
              </Table.Cell>
            {/if}

            {#if displayIncVat}
              <Table.Cell class="text-right">
                {formatCurrency(margin.discountIncVat, projectPrices.currency)}
              </Table.Cell>
            {:else}
              <Table.Cell class="text-right">
                {formatCurrency(margin.discountExVat, projectPrices.currency)}
              </Table.Cell>
            {/if}

            {#if marginVisible}
              <Table.Cell class="text-right">
                <PriceMarginAmount value={margin.marginExVat} currency={projectPrices.currency} />
              </Table.Cell>
            {/if}
          </Table.Row>
        {/each}
      </Table.Body>
    </Table.Root>

    
    <TotalAmountsTable {marginVisible} />
    
  </Card.Content>
</Card.Root>
